module.exports = "https://static.wmbcdn.com/uniweb/images/c0da8bab33790fdb9abf721a6c7f91e8.svg";